const config = {
  ssoUrl: 'https://web1.test.ezlogz.com/ezloads',
};

export default config;
